export default __webpack_public_path__ + "static/media/profileIcon.75625e68.svg";